import { useQuery } from '@tanstack/react-query'
import type { ToGeoJSON } from '../../types/apiModels'
import { getOtherPolygons } from '../../services/farmMapping/otherPolygons/getOtherPolygons'
import { queryKeys } from './queryKeys'

// Stable select identity; the clone stops consumers' featureGroup rewrites reaching the cache.
const selectFeatures = (features: ToGeoJSON[]): ToGeoJSON[] => structuredClone(features)

export const useOtherPolygons = ({ farmId }: { farmId: string | undefined }) =>
  useQuery({
    queryKey: queryKeys.otherPolygons(farmId),
    queryFn: ({ signal }) => getOtherPolygons({ farmId: farmId as string, signal }),
    enabled: !!farmId,
    select: selectFeatures,
  })
